import { recalculateOtherFeesPrices } from 'helpers/otherFeesCalculation';
import { buildOptionsPayload, getIncludedOptions, getProposedOptions } from './StoreProposedOptions';
export { recalculateOtherFeesPrices };
function toDealItemInputOptions(source) {
    if (source == null) {
        return [];
    }
    return source.map((entry) => {
        var _a, _b, _c, _d;
        return ({
            item: (_a = entry.item) === null || _a === void 0 ? void 0 : _a.id,
            price: entry.price,
            feeValue: entry.feeValue,
            quantity: entry.quantity,
            proposed: entry.proposed,
            included: entry.included,
            initiallyProposed: entry.initiallyProposed,
            alternativeTo: entry.alternativeTo,
            priceDisplay: entry.priceDisplay,
            startTime: (_b = entry.startTime) !== null && _b !== void 0 ? _b : null,
            endTime: (_c = entry.endTime) !== null && _c !== void 0 ? _c : null,
            fieldValues: (_d = entry.fieldValues) === null || _d === void 0 ? void 0 : _d.map((fieldValue) => {
                var _a;
                return ({
                    fieldId: (_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id,
                    value: JSON.stringify({ value: JSON.parse(fieldValue.value).value })
                });
            })
        });
    });
}
function toDealItemPackageInput(source) {
    if (source == null) {
        return [];
    }
    return source.map((entry) => {
        var _a, _b, _c, _d;
        return ({
            package: (_a = entry.package) === null || _a === void 0 ? void 0 : _a.id,
            price: entry.price,
            quantity: entry.quantity,
            proposed: entry.proposed,
            initiallyProposed: entry.initiallyProposed,
            alternativeTo: entry.alternativeTo,
            priceDisplay: entry.priceDisplay,
            startTime: (_b = entry.startTime) !== null && _b !== void 0 ? _b : null,
            endTime: (_c = entry.endTime) !== null && _c !== void 0 ? _c : null,
            fieldValues: (_d = entry.fieldValues) === null || _d === void 0 ? void 0 : _d.map((fieldValue) => {
                var _a;
                return ({
                    fieldId: (_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id,
                    value: JSON.stringify({ value: JSON.parse(fieldValue.value).value })
                });
            })
        });
    });
}
function toUpdateDealItemInput(source, unitsByLine) {
    return source.map((item) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, ((unitsByLine === null || unitsByLine === void 0 ? void 0 : unitsByLine.has(item.id)) ? { units: unitsByLine.get(item.id) } : {})), { id: item.id, item: item.item.id, quantity: item.quantity, price: item.price, proposed: (_a = item.proposed) !== null && _a !== void 0 ? _a : false, initiallyProposed: (_b = item.initiallyProposed) !== null && _b !== void 0 ? _b : false, alternativeTo: item.alternativeTo, options: toDealItemInputOptions(item.options), packages: toDealItemPackageInput(item.packages) }));
    });
}
/**
 * @function removeDealItem
 * @since 1.0.0
 */
export function removeDealItem(deal, itemId) {
    var _a, _b;
    return Object.assign(Object.assign({}, deal), { items: (_b = (_a = deal.items) === null || _a === void 0 ? void 0 : _a.filter((item) => item.id !== itemId)) !== null && _b !== void 0 ? _b : [] });
}
/**
 * @function removeDealItemOption
 * @since 1.0.0
 */
export function removeDealItemOption(deal, itemId, optionId) {
    var _a, _b;
    return Object.assign(Object.assign({}, deal), { items: (_b = (_a = deal.items) === null || _a === void 0 ? void 0 : _a.map((item) => {
            var _a, _b;
            if (item.id !== itemId) {
                return item;
            }
            return Object.assign(Object.assign({}, item), { options: (_b = (_a = item.options) === null || _a === void 0 ? void 0 : _a.map((option) => {
                    if (option.id !== optionId || option.included) {
                        return option;
                    }
                    return Object.assign(Object.assign({}, option), { proposed: true, initiallyProposed: option.initiallyProposed || true });
                })) !== null && _b !== void 0 ? _b : [] });
        })) !== null && _b !== void 0 ? _b : [] });
}
function extraOptionsForItem(item, extras, createdAt, updatedAt) {
    return extras.map((opt) => {
        var _a;
        const existing = (_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.find((option) => { var _a; return ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) === opt.itemId && !option.included; });
        if (existing) {
            return Object.assign(Object.assign({}, existing), { quantity: opt.quantity, price: opt.price, proposed: false, priceDisplay: existing.priceDisplay || 'AMOUNT' });
        }
        return {
            id: opt.itemId,
            quantity: opt.quantity,
            price: opt.price,
            proposed: false,
            included: false,
            initiallyProposed: true,
            priceDisplay: 'AMOUNT',
            type: 'OPTION',
            hide: false,
            createdAt,
            updatedAt,
            item: { id: opt.itemId }
        };
    });
}
function remainingProposedOptionsForItem(item, saleItem, extras, quantity, createdAt, updatedAt) {
    var _a, _b;
    const extraIds = new Set(extras.map((opt) => opt.itemId));
    const fromDeal = (_b = (_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.filter((option) => {
        var _a;
        return option.proposed &&
            !option.included &&
            ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) != null &&
            !extraIds.has(option.item.id);
    })) !== null && _b !== void 0 ? _b : [];
    if (fromDeal.length > 0 || !saleItem) {
        return fromDeal;
    }
    return getProposedOptions(saleItem)
        .filter((option) => { var _a; return ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) && !extraIds.has(option.item.id); })
        .map((option) => {
        var _a, _b, _c, _d;
        return ({
            id: (_b = (_a = option.item) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
            quantity: option.quantityEditable
                ? option.quantity
                : option.quantity * quantity,
            price: option.price,
            proposed: true,
            included: false,
            initiallyProposed: true,
            priceDisplay: 'AMOUNT',
            type: 'OPTION',
            hide: false,
            createdAt,
            updatedAt,
            item: (_c = option.item) !== null && _c !== void 0 ? _c : { id: (_d = option.item) === null || _d === void 0 ? void 0 : _d.id }
        });
    });
}
function includedOptionsForItem(item, saleItem, quantity, createdAt, updatedAt) {
    var _a, _b;
    const includedFromDeal = (_b = (_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.filter((option) => option.included)) !== null && _b !== void 0 ? _b : [];
    if (includedFromDeal.length > 0) {
        return includedFromDeal;
    }
    if (!saleItem) {
        return [];
    }
    return getIncludedOptions(saleItem).map((option) => {
        var _a, _b, _c, _d;
        return ({
            id: (_b = (_a = option.item) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
            quantity: option.quantity * quantity,
            price: option.price,
            proposed: false,
            included: true,
            priceDisplay: option.price === 0 ? 'INCLUDED' : 'AMOUNT',
            type: 'OPTION',
            hide: false,
            createdAt,
            updatedAt,
            item: (_c = option.item) !== null && _c !== void 0 ? _c : { id: (_d = option.item) === null || _d === void 0 ? void 0 : _d.id }
        });
    });
}
/**
 * Rebuilds deal items from the current store selection (add, remove, quantity, options).
 * @function applyStoreSelectionToDeal
 * @since 1.0.0
 */
export function applyStoreSelectionToDeal(deal, selectedItems, saleItems) {
    var _a;
    const extrasByItemId = new Map(buildOptionsPayload(selectedItems, saleItems).map((entry) => [
        entry.itemId,
        entry.options
    ]));
    const timestamp = (_a = deal.updatedAt) !== null && _a !== void 0 ? _a : deal.createdAt;
    return Object.assign(Object.assign({}, deal), { items: selectedItems.map((selected) => {
            var _a, _b, _c, _d, _e;
            const existing = (_a = deal.items) === null || _a === void 0 ? void 0 : _a.find((item) => item.item.id === selected.id && !item.proposed);
            const saleItem = saleItems.find((entry) => entry.id === selected.id);
            const extras = (_b = extrasByItemId.get(selected.id)) !== null && _b !== void 0 ? _b : [];
            const createdAt = (_c = existing === null || existing === void 0 ? void 0 : existing.createdAt) !== null && _c !== void 0 ? _c : timestamp;
            const updatedAt = (_d = existing === null || existing === void 0 ? void 0 : existing.updatedAt) !== null && _d !== void 0 ? _d : timestamp;
            const options = [
                ...includedOptionsForItem(existing, saleItem, selected.quantity, createdAt, updatedAt),
                ...extraOptionsForItem(existing, extras, createdAt, updatedAt),
                ...remainingProposedOptionsForItem(existing, saleItem, extras, selected.quantity, createdAt, updatedAt)
            ];
            if (existing) {
                return Object.assign(Object.assign({}, existing), { quantity: selected.quantity, options });
            }
            return {
                id: selected.id,
                quantity: selected.quantity,
                proposed: false,
                initiallyProposed: false,
                price: (_e = saleItem === null || saleItem === void 0 ? void 0 : saleItem.price) !== null && _e !== void 0 ? _e : 0,
                order: 0,
                createdAt,
                updatedAt,
                item: saleItem !== null && saleItem !== void 0 ? saleItem : { id: selected.id },
                options,
                packages: []
            };
        }) });
}
/**
 * @function buildStoreDealUpdateInput
 * @since 1.0.0
 */
export function buildStoreDealUpdateInput(deal, unitsByLine) {
    var _a;
    const recalculatedOtherFees = recalculateOtherFeesPrices(deal);
    return {
        id: deal.id,
        items: toUpdateDealItemInput((_a = deal.items) !== null && _a !== void 0 ? _a : [], unitsByLine),
        otherFees: recalculatedOtherFees.map((fee) => {
            var _a;
            return ({
                fee: (_a = fee.fee) === null || _a === void 0 ? void 0 : _a.id,
                description: fee.description,
                price: fee.price
            });
        }),
        discountType: deal.discountType
    };
}
